import React from 'react';

const GearsIcon = props => (
  <svg viewBox="0 0 178.07 143.69" {...props}>
    <title>Gears</title>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="22.04"
        y1="36.51"
        x2="58.76"
        y2="36.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor={Styles.color.primary} />
        <stop offset="0.63" stopColor={Styles.color.primary} stopOpacity="0.4" />
        <stop offset="1" stopColor={Styles.color.primary} stopOpacity="0.7" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" x1="137.55" y1="114.42" x2="114.3" y2="50.53" />
    </defs>
    <title>Asset 1</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          style={{ fill: Styles.color.primary }}
          d="M177.17,96.93l.9-8.56-11-3.09c0-.09,0-.18,0-.27a48.12,48.12,0,0,0-.58-7.45L177,72.07l-2.66-8.18-11.35,1.65a47.84,47.84,0,0,0-3.8-6.92l7.17-9.08-5.76-6.4L151,49.2a48.33,48.33,0,0,0-6.45-4.82L147.42,33l-7.87-3.5-6.46,9.68a47.11,47.11,0,0,0-7.55-1.62l-2-11.7h-8.61l-2,11.69a48.75,48.75,0,0,0-7.68,1.65l-6.47-9.7L90.92,33l2.91,11.42a47.9,47.9,0,0,0-6.42,4.8l-9.63-6.09L72,49.54l7.22,9.14a47.14,47.14,0,0,0-3.77,6.87L64,63.89l-2.66,8.18,10.51,5.52,0-.16a48.56,48.56,0,0,0-.6,7.58v.24L60.27,88.37l.9,8.56L73,97.69l0-.21a47,47,0,0,0,2.34,6.67l-8.92,7.41L70.72,119l11.11-4.11a48.33,48.33,0,0,0,4.82,5.19l-5.16,10.45,7,5.06,8.45-8.24a47.29,47.29,0,0,0,6.68,2.9l-.47,11.64,8.43,1.79,4.35-10.94c1.1.08,2.2.13,3.32.13s2.17,0,3.24-.12l4.35,10.93,8.42-1.79-.47-11.61a47.77,47.77,0,0,0,6.72-2.9l8.41,8.21,7-5.06-5.13-10.39a48.93,48.93,0,0,0,4.86-5.22l11,4.08,4.31-7.45-8.85-7.36a47.8,47.8,0,0,0,2.3-6.51Zm-58-7.72a4.2,4.2,0,1,1,4.2-4.2A4.2,4.2,0,0,1,119.21,89.21Z"
        />
        <path
          style={{ fill: Styles.color.primary }}
          d="M69,40.18l8.58-3.47L76,28.23l-9-.32a30,30,0,0,0-4.29-7.64L67.09,12l-6.6-5.54-7.28,5.69a30,30,0,0,0-8.13-3L43.13,0H34.52l-2,9.18a30,30,0,0,0-8.18,3L17.05,6.48,10.45,12l4.42,8.33a30.1,30.1,0,0,0-4.23,7.56l-9.15.32L0,36.71l8.68,3.51a30.22,30.22,0,0,0,1.8,8.86l-6.64,6,4.31,7.46,8.93-2.9a30.38,30.38,0,0,0,6.59,5.18l-1.25,8.94,8.09,3,5-8a30.18,30.18,0,0,0,3.31.18A30.78,30.78,0,0,0,42,68.71l5,8,8.09-3-1.25-8.88a30.2,30.2,0,0,0,6.67-5.21l8.85,2.87,4.31-7.46-6.56-5.91A30,30,0,0,0,69,40.18ZM38.82,42.67a4,4,0,1,1,4-4A4,4,0,0,1,38.82,42.67Z"
        />
        <path
          style={{ fill: 'url(#linear-gradient)' }}
          d="M38.8,18.67A19.9,19.9,0,0,0,22,27.83a19.93,19.93,0,0,1,29,26.52A19.93,19.93,0,0,0,38.8,18.67Z"
        />
        <path
          style={{ fill: 'url(#linear-gradient' }}
          d="M119.21,50.93a34,34,0,0,0-28,14.72A33.22,33.22,0,0,1,134,115.7a34.09,34.09,0,0,0-14.83-64.77Z"
        />
      </g>
    </g>
  </svg>
);

export default GearsIcon;
